/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Priority_StaleInputs */

const en_orders_priority_stale = /** @type {(inputs: Orders_Priority_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3+ Days`)
};

const es_orders_priority_stale = /** @type {(inputs: Orders_Priority_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3+ dias`)
};

/**
* | output |
* | --- |
* | "3+ Days" |
*
* @param {Orders_Priority_StaleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_priority_stale = /** @type {((inputs?: Orders_Priority_StaleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Priority_StaleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_priority_stale(inputs)
	return es_orders_priority_stale(inputs)
});